import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";
import { ReviewRating } from "common/types";

import { ModalStatus } from "client/common/types";
import { makeClientRoutes } from "client/routes/types";

import { OrderSearch } from "../types";

const paths = {
  list: "/",
  detail: "/:id",
  payment: "/:id/payment",
};

type OrderDetailParams = {
  id: number;
};

type OrderPaymentParams = {
  id: number;
};

type OrdersSearch = {
  reviewCreateModalIsVisible?: ModalStatus;
  productLineId?: number;
  initialRating?: ReviewRating;
  modificationsModalIsVisible?: ModalStatus;
  orderId?: number;
  cancelationModalIsVisible?: ModalStatus;
};

type OrderPathdefinitions = {
  list: { Search: OrdersSearch };
  detail: { Params: OrderDetailParams; Search: OrderSearch };
  payment: { Params: OrderPaymentParams };
};

export type OrderPaths = MakePaths<OrderPathdefinitions>;

export const useOrderRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    { path: paths.list, element: () => import("../components/OrdersPage"), pageName: "orders" },
    {
      path: paths.payment,
      element: () => import("../components/OrderPaymentPage"),
      pageName: "order_payment",
    },
    { path: paths.detail, element: () => import("../components/OrderPage"), pageName: "order" },
  ]);
};

export const makeOrderUrls = (base: string) => {
  return makeUrls<OrderPathdefinitions>(base, {
    list: { path: paths.list },
    detail: { path: paths.detail, to: ({ id }) => `/${id}` },
    payment: { path: paths.payment, to: ({ id }) => `/${id}/payment` },
  });
};
